import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/welfare',
  component: Layout,
  redirect: '/welfare',
  name: 'welfare',
  meta: {
    title: '福利品',
    icon: 'welfare',
  },
  children: [
    {
        path: 'index',
        name: 'welfareIndex',
        component: () => import('@/views/welfare/index.vue'),
        meta: {
            title: '合同管理',
            breadcrumb: true,
            auth: [
                'Welfare.Welfare.menu'
            ]
        }
    },
    {
      path: 'detail/:id',
      name: 'welfareDetail',
      component: () => import('@/views/welfare/detail.vue'),
      meta: {
        title: '合同详情',
        menu: false,
        activeMenu: '/welfare/index',
        auth: [
            'Welfare.Welfare.menu'
        ]
      },
    },
  ],
}

export default routes
